import { Draft } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

function addNoteFailure(draft: Draft<IInterventionData>) {
  draft.addNote.config.isLoading = false;
}

export default addNoteFailure;
